
import { useRef } from "react";
import { Node, Edge, NodeMouseHandler, EdgeMouseHandler } from "@xyflow/react";
import { DiagramCanvas } from "./DiagramCanvas";
import { ComponentSidebar } from "./ComponentSidebar";
import { NodeData } from "./initial-nodes";
import { Component } from "@/utils/types/componentTypes";

interface DiagramEditorAreaProps {
  nodes: Node<NodeData>[];
  edges: Edge[];
  onNodesChange: (changes: any) => void;
  onEdgesChange: (changes: any) => void;
  setNodes: React.Dispatch<React.SetStateAction<Node<NodeData>[]>>;
  setEdges: React.Dispatch<React.SetStateAction<Edge[]>>;
  onNodeContextMenu: NodeMouseHandler;
  onEdgeContextMenu: EdgeMouseHandler;
  onPaneClick: () => void;
  components: Component[];
  isLoading: boolean;
  diagramName?: string;
  setReactFlowInstance: (instance: any) => void;
  onSave: () => void;
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  subscriptionId?: string;
  refreshComponents?: () => Promise<void>;
  onAddNew: () => void;
  selectedElements: { nodes: Node<NodeData>[]; edges: Edge[] };
  onElementsSelect: (nodes: Node<NodeData>[], edges: Edge[]) => void;
  onNodeClick: (event: React.MouseEvent, node: Node<NodeData>) => void;
  onEdgeClick: (event: React.MouseEvent, edge: Edge) => void;
  onNodeDoubleClick?: (event: React.MouseEvent, node: Node<NodeData>) => void;
  onEdgeDoubleClick?: (event: React.MouseEvent, edge: Edge) => void;
  autoSaveStatus?: { isSaving: boolean; lastSaved?: Date; error?: Error };
}

export function DiagramEditorArea({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  setNodes,
  setEdges,
  onNodeContextMenu,
  onEdgeContextMenu,
  onPaneClick,
  components,
  isLoading,
  diagramName,
  setReactFlowInstance,
  onSave,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  subscriptionId,
  refreshComponents,
  onAddNew,
  selectedElements,
  onElementsSelect,
  onNodeClick,
  onEdgeClick,
  onNodeDoubleClick,
  onEdgeDoubleClick,
  autoSaveStatus,
}: DiagramEditorAreaProps) {
  const reactFlowWrapper = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-1 h-full overflow-hidden">
      <ComponentSidebar
        components={components}
        loading={isLoading}
        diagramName={diagramName}
        refreshComponents={refreshComponents}
      />
      <div className="flex-1 h-full" ref={reactFlowWrapper}>
        <DiagramCanvas
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          setNodes={setNodes}
          setEdges={setEdges}
          onNodeContextMenu={onNodeContextMenu}
          onEdgeContextMenu={onEdgeContextMenu}
          onPaneClick={onPaneClick}
          setReactFlowInstance={setReactFlowInstance}
          subscriptionId={subscriptionId}
          onSave={onSave}
          onUndo={onUndo}
          onRedo={onRedo}
          canUndo={canUndo}
          canRedo={canRedo}
          onAddNew={onAddNew}
          selectedElements={selectedElements}
          onElementsSelect={onElementsSelect}
          onNodeClick={onNodeClick}
          onEdgeClick={onEdgeClick}
          onNodeDoubleClick={onNodeDoubleClick}
          onEdgeDoubleClick={onEdgeDoubleClick}
          autoSaveStatus={autoSaveStatus}
          diagramName={diagramName}
        />
      </div>
    </div>
  );
}
